import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";

var FilterSection = function FilterSection(_ref) {
  var children = _ref.children,
      title = _ref.title;
  var getClassName = getClassNameFactory("SearchFiltersFilterSection");
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "title",
      utilities: "typographySmallCaps"
    })
  }, title), /*#__PURE__*/React.createElement("ul", {
    className: getClassName({
      descendantName: "items"
    })
  }, children));
};

FilterSection.displayName = "SearchFilters.FilterSection";
export default FilterSection;